import ACTION from "../../actions";

const initialState = {
  signingListingData: [],
  addCommentData: {},
  commentList: [],
};

const agreementsReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTION.SIGNING_LISTING:
      return {
        ...state,
        signingListingData: action.payload,
      };
    case ACTION.ADD_COMMENT:
      return {
        ...state,
        addCommentData: action.payload,
      };
    case ACTION.COMMENT_LISTING:
      return {
        ...state,
        commentList: action.payload,
      };
    default:
      return state;
  }
};

export default agreementsReducer;
